import { render } from "./reviewRate.vue?vue&type=template&id=2561e8cd&scoped=true"
import script from "./reviewRate.js?vue&type=script&lang=js"
export * from "./reviewRate.js?vue&type=script&lang=js"

import "./reviewRate.vue?vue&type=style&index=0&id=2561e8cd&scoped=true&lang=scss"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2561e8cd"]])

export default __exports__